import { INormalizedObjects } from '../types'
export default function normalize<T extends { id: string }>(items: T[]): INormalizedObjects<T> {
  return items.reduce(
    ({ ids, byId }: INormalizedObjects<T>, item: T) => ({
      ids: [...ids, item.id],
      byId: { ...byId, [item.id]: item },
    }),
    { ids: [], byId: {} }
  )
}

export function normalizeSpaces<T extends { id: string }>(items: T[]): INormalizedObjects<T> {
  return items.reduce(
    ({ ids, byId }: INormalizedObjects<T>, item: T) => ({
      ids: [...ids, item.id],
      byId: { ...byId, [item.id]: item },
      raw: items,
    }),
    { ids: [], byId: {}, raw: [] }
  )
}
